"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var context_1 = __importDefault(require("./context"));
var useLDClient = function () {
    var ldClient = react_1.useContext(context_1.default).ldClient;
    return ldClient;
};
exports.default = useLDClient;
//# sourceMappingURL=useLDClient.js.map